"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSolutionsFromDomain = exports.getDomainFromSolution = exports.isInsulationSolution = exports.Solutions = exports.SOLUTION_PREFIXES = exports.SOLUTIONS_NL = exports.SOLUTIONS = exports.Solution = exports.SOLUTION_DOMAINS_NL = exports.SOLUTION_DOMAINS = exports.SolutionDomain = void 0;
const typeHelpers_1 = require("./typeHelpers");
/* * * * * * * * * * *
 * Solution Domains  *
 * * * * * * * * * * */
var SolutionDomain;
(function (SolutionDomain) {
    SolutionDomain["PvSystem"] = "pvSystem";
    SolutionDomain["WallInsulation"] = "wallInsulation";
    SolutionDomain["FloorInsulation"] = "floorInsulation";
    SolutionDomain["RoofInsulation"] = "roofInsulation";
    SolutionDomain["InsulationGlazing"] = "insulationGlazing";
    SolutionDomain["Heating"] = "heating";
    SolutionDomain["Miscellaneous"] = "miscellaneous";
})(SolutionDomain = exports.SolutionDomain || (exports.SolutionDomain = {}));
exports.SOLUTION_DOMAINS = (0, typeHelpers_1.enumValues)(SolutionDomain);
exports.SOLUTION_DOMAINS_NL = {
    [SolutionDomain.PvSystem]: 'Zonnepanelen',
    [SolutionDomain.WallInsulation]: 'Spouwmuurisolatie',
    [SolutionDomain.FloorInsulation]: 'Vloerisolatie',
    [SolutionDomain.RoofInsulation]: 'Dakisolatie',
    [SolutionDomain.InsulationGlazing]: 'Isolatieglas',
    [SolutionDomain.Heating]: 'Verwarming',
    [SolutionDomain.Miscellaneous]: 'Overige',
};
/* * * * * * * * * * *
 * Solutions         *
 * * * * * * * * * * */
/**
 * Solution is an enum containing all the different categories of energy saving measures that we provide in at Energiebespaarders.
 */
exports.Solution = {
    PvSystem: 'pvSystem',
    WallInsulation: 'wallInsulation',
    FloorInsulation: 'floorInsulation',
    CrawlspaceInsulation: 'crawlspaceInsulation',
    InnerRoofInsulation: 'innerRoofInsulation',
    AtticFloorInsulation: 'atticFloorInsulation',
    CentralHeatingBoiler: 'centralHeatingBoiler',
    ElectricHeatPump: 'electricHeatPump',
    HybridHeatPump: 'hybridHeatPump',
    AirToAirHeatPump: 'airToAirHeatPump',
    UnderfloorHeating: 'underfloorHeating',
    ChargingBox: 'chargingBox',
    HomeBattery: 'homeBattery',
    Sedum: 'sedum',
    WindowFrames: 'windowFrames',
    WindowGlazing: 'windowGlazing',
    Miscellaneous: 'miscellaneous',
};
exports.SOLUTIONS = (0, typeHelpers_1.enumValues)(exports.Solution);
exports.SOLUTIONS_NL = {
    [exports.Solution.CentralHeatingBoiler]: 'CV-ketel',
    [exports.Solution.HybridHeatPump]: 'Hybride warmtepomp',
    [exports.Solution.ElectricHeatPump]: 'Elektrische warmtepomp',
    [exports.Solution.AirToAirHeatPump]: 'Airco',
    [exports.Solution.UnderfloorHeating]: 'Vloerverwarming',
    [exports.Solution.WallInsulation]: 'Spouwmuurisolatie',
    [exports.Solution.FloorInsulation]: 'Vloerisolatie',
    [exports.Solution.CrawlspaceInsulation]: 'Bodemisolatie',
    [exports.Solution.InnerRoofInsulation]: 'Dakisolatie binnenzijde',
    [exports.Solution.AtticFloorInsulation]: 'Zoldervloerisolatie',
    [exports.Solution.PvSystem]: 'Zonnepanelen',
    [exports.Solution.WindowGlazing]: 'Isolatieglas',
    [exports.Solution.WindowFrames]: 'Kozijnen',
    [exports.Solution.Sedum]: 'Sedum',
    [exports.Solution.ChargingBox]: 'Laadpaal',
    [exports.Solution.HomeBattery]: 'Thuisbatterij',
    [exports.Solution.Miscellaneous]: 'Overige',
};
/** A unique two-character uppercase abbreviation of a Solution */
exports.SOLUTION_PREFIXES = {
    [exports.Solution.PvSystem]: 'PV',
    [exports.Solution.WallInsulation]: 'SP',
    [exports.Solution.FloorInsulation]: 'VL',
    [exports.Solution.CrawlspaceInsulation]: 'BO',
    [exports.Solution.InnerRoofInsulation]: 'DK',
    [exports.Solution.AtticFloorInsulation]: 'ZV',
    [exports.Solution.CentralHeatingBoiler]: 'CV',
    [exports.Solution.HybridHeatPump]: 'HY',
    [exports.Solution.ElectricHeatPump]: 'WP',
    [exports.Solution.AirToAirHeatPump]: 'AC',
    [exports.Solution.UnderfloorHeating]: 'VV',
    [exports.Solution.WindowGlazing]: 'GL',
    [exports.Solution.WindowFrames]: 'KZ',
    [exports.Solution.Sedum]: 'SD',
    [exports.Solution.ChargingBox]: 'LP',
    [exports.Solution.HomeBattery]: 'TB',
    [exports.Solution.Miscellaneous]: 'OV',
};
exports.Solutions = {
    all: exports.SOLUTIONS,
    insulation: [
        exports.Solution.AtticFloorInsulation,
        exports.Solution.CrawlspaceInsulation,
        exports.Solution.FloorInsulation,
        exports.Solution.InnerRoofInsulation,
        exports.Solution.WallInsulation,
        exports.Solution.WindowGlazing,
    ],
    /** Solutions that do not (significantly) affect the energy savings or production */
    nonEnergySaving: [
        exports.Solution.Miscellaneous,
        exports.Solution.ChargingBox,
        exports.Solution.Sedum,
        exports.Solution.AirToAirHeatPump,
        exports.Solution.UnderfloorHeating,
        exports.Solution.HomeBattery,
    ],
};
function isInsulationSolution(solution) {
    return exports.Solutions.insulation.includes(solution);
}
exports.isInsulationSolution = isInsulationSolution;
function getDomainFromSolution(solution) {
    switch (solution) {
        case exports.Solution.CentralHeatingBoiler:
        case exports.Solution.HybridHeatPump:
        case exports.Solution.ElectricHeatPump:
        case exports.Solution.AirToAirHeatPump:
        case exports.Solution.UnderfloorHeating:
            return SolutionDomain.Heating;
        case exports.Solution.WallInsulation:
            return SolutionDomain.WallInsulation;
        case exports.Solution.FloorInsulation:
            return SolutionDomain.FloorInsulation;
        case exports.Solution.CrawlspaceInsulation:
            return SolutionDomain.FloorInsulation;
        case exports.Solution.InnerRoofInsulation:
            return SolutionDomain.RoofInsulation;
        case exports.Solution.AtticFloorInsulation:
            return SolutionDomain.RoofInsulation;
        case exports.Solution.PvSystem:
            return SolutionDomain.PvSystem;
        case exports.Solution.WindowGlazing:
            return SolutionDomain.InsulationGlazing;
        case exports.Solution.WindowFrames:
            return SolutionDomain.InsulationGlazing;
        case exports.Solution.Miscellaneous:
        case exports.Solution.Sedum:
        case exports.Solution.ChargingBox:
        case exports.Solution.HomeBattery:
            return SolutionDomain.Miscellaneous;
        default:
            throw new Error(`No solution domain found for solution "${solution}"`);
    }
}
exports.getDomainFromSolution = getDomainFromSolution;
function getSolutionsFromDomain(solution) {
    switch (solution) {
        case SolutionDomain.FloorInsulation:
            return [exports.Solution.FloorInsulation, exports.Solution.CrawlspaceInsulation];
        case SolutionDomain.WallInsulation:
            return [exports.Solution.WallInsulation];
        case SolutionDomain.RoofInsulation:
            return [exports.Solution.InnerRoofInsulation, exports.Solution.AtticFloorInsulation];
        case SolutionDomain.InsulationGlazing:
            return [exports.Solution.WindowGlazing, exports.Solution.WindowFrames];
        case SolutionDomain.PvSystem:
            return [exports.Solution.PvSystem];
        case SolutionDomain.Heating:
            return [
                exports.Solution.CentralHeatingBoiler,
                exports.Solution.ElectricHeatPump,
                exports.Solution.HybridHeatPump,
                exports.Solution.AirToAirHeatPump,
                exports.Solution.UnderfloorHeating,
            ];
        case SolutionDomain.Miscellaneous:
            return [exports.Solution.Sedum, exports.Solution.ChargingBox, exports.Solution.HomeBattery, exports.Solution.Miscellaneous];
        default:
            return [];
    }
}
exports.getSolutionsFromDomain = getSolutionsFromDomain;
